module.exports = __webpack_public_path__ + "img/rads_radshroomers.753e543.png";